window.ItensNotaFiscalEntradaController = ControllerBase.extend({
    name: 'ItensNotaFiscalEntradaController',
    framework: 'knockout',

    //dataBreadcrumb: new DataBreadcrumb({
    //    columns: [
    //        { title: 'Filial', prop: 'DescricaoFilial' },
    //        { title: 'Nota', prop: 'Numero' },
    //        { title: 'Serie', prop: 'Serie' },
    //        { title: 'Chegada', prop: 'DataChegada', type: 'Date' },
    //        { title: 'Valor', prop: 'ValorTotal', type: 'Money' },
    //    ],
    //    getData: function () {
    //        return ko.mapping.toJS(this.notaFiscal);
    //    },
    //}),

    ajax: function() {
        return {
            url: '/NotaFiscalEntrada/_Itens',
            type: 'post',
            data: {
                codigoNotaFiscal: this.notaFiscal.Codigo()
            }
        };
    }
});